module.exports = __webpack_public_path__ + "housingStatic/img/noImg.643f1c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/noImg.jpg
// module id = 2m54
// module chunks = 2